import CircularProgress from "@mui/material/CircularProgress";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import BatteryGauge from "react-battery-gauge";
import "./hover.css";

const ListSensorTanpaIndicator = (props) => {
  const navigate = useNavigate();
  const goSensor = (e) => {
    $("button.close").click();
    navigate(`/sensor-monitor/chart/${props.ipc}/${e}`);
  };

  const translate = (data) => {
    let rssiImg;
    let isDetected;
    let lastDetected = "-";
    let lastRead = "-";
    let lastTrigered = "-";
    if (data.rssi <= -90) {
      rssiImg = "/img/icon/wifi_0.svg";
    } else if (data.rssi > -90 && data.rssi <= -80) {
      rssiImg = "/img/icon/wifi_1.svg";
    } else if (data.rssi > -80 && data.rssi <= -70) {
      rssiImg = "/img/icon/wifi_2.svg";
    } else if (data.rssi > -70 && data.rssi <= -65) {
      rssiImg = "/img/icon/wifi_3.svg";
    } else if (data.rssi > -65) {
      rssiImg = "/img/icon/wifi_4.svg";
    }

    if (data.isDetected) {
      isDetected = "Detected";
    } else {
      isDetected = "Not Detected";
    }

    if (data.lastDetected !== 0) {
      //   console.log("SINI", data.lastDetected);
      const numEpoch = Number.parseInt(data.lastDetected);
      const date = new Date(numEpoch);
      const splitDate = date.toString().split(" ");
      const dateRemovedGMT = `${splitDate[0]}, ${splitDate[2]} ${splitDate[1]} ${splitDate[3]} - ${splitDate[4]}`;
      lastDetected = dateRemovedGMT;
      //   console.log("DATE DETECTED", lastDetected);
    }

    if (data.lastRead !== 0) {
      //   console.log("SINI", data.lastRead);
      const numEpoch = Number.parseInt(data.lastRead);
      const date = new Date(numEpoch);
      const splitDate = date.toString().split(" ");
      const dateRemovedGMT = `${splitDate[0]}, ${splitDate[2]} ${splitDate[1]} ${splitDate[3]} - ${splitDate[4]}`;
      lastRead = dateRemovedGMT;
      //   console.log("DATE", lastRead);
    }

    if (data.lastTrigered !== 0) {
      //   console.log("SINI", data.lastTrigered);
      const numEpoch = Number.parseInt(data.lastTrigered);
      const date = new Date(numEpoch);
      const splitDate = date.toString().split(" ");
      const dateRemovedGMT = `${splitDate[0]}, ${splitDate[2]} ${splitDate[1]} ${splitDate[3]} - ${splitDate[4]}`;
      lastTrigered = dateRemovedGMT;
      //   console.log("DATE TRIGGERED", lastTrigered);
    }

    return { rssiImg, lastRead, lastDetected, lastTrigered, isDetected };
  };

  const Getdata = () => {
    return props.data.map((e, i) => {
      return (
        <div className="col-12 mb-2" key={i}>
          <div className="bg-white px-4 py-2 rounded-banget shadow d-flex justify-content-between align-items-center">
            <span style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <h4
                    className="mb-0 hover"
                    onClick={() => {
                      goSensor(e.idSensor);
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {e.group} {e.numberSensor}
                  </h4>
                  <img
                    style={{
                      width: "25px",
                      height: "25px",
                      paddingBottom: "0.3em",
                    }}
                    src={translate(e).rssiImg}
                    alt="rssi"
                  />
                </span>
                {!props.ipc.includes("IPCC") && (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                    }}
                    className="text-warning"
                    onClick={() => {
                      $("button.close").click();
                      navigate(`/sensor-monitor/history/${e.idSensor}`);
                    }}
                  >
                    <i
                      className="las la-history mr-1"
                      style={{
                        fontSize: "25px",
                      }}
                    ></i>
                    <label
                      style={{
                        cursor: "pointer",
                        alignSelf: "center",
                        margin: "0px",
                        padding: "0px",
                        fontSize: "0.8rem",
                      }}
                      className="hover"
                    >
                      History
                    </label>
                  </span>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  fontSize: "0.8rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <label
                    style={{
                      color: "#33B5E5",
                    }}
                  >
                    {translate(e).lastDetected}
                  </label>
                  <label>Status: {translate(e).isDetected}</label>
                  <label>Recording: {e.isRecording ? "True" : "False"}</label>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <label>Last Read: {translate(e).lastRead}</label>
                  <label>Last Triggered: {translate(e).lastTrigered}</label>
                </div>
              </div>
            </span>
          </div>
        </div>
      );
    });
  };
  return (
    <div
      className="modal fade"
      id="listSensor_modal"
      tabIndex={-1}
      aria-labelledby="listSensor_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h2
                style={{
                  fontWeight: "bold",
                  padding: "0em",
                  margin: "0em",
                }}
                clasName="mb-0 ml-2"
              >
                List Sensor {props.data?.sensor}
              </h2>
            </div>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            {!props.data ? (
              <div className="d-flex py-4 justify-content-center">
                <CircularProgress />
              </div>
            ) : (
              <div className="row" style={{ gap: "10px" }}>
                <Getdata />
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ListSensorTanpaIndicator;
